import { Globe, Menu, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Can } from '../guards';
import { NotificationsMenu } from '../../features/notifications/NotificationsMenu';
import { NAV_ITEMS } from './nav';
import { SearchBox } from './SearchBox';

function useDateLabel(lang: string) {
  const now = new Date();
  return new Intl.DateTimeFormat(lang === 'en' ? 'en-EG' : 'ar-EG-u-nu-latn', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'Africa/Cairo',
  }).format(now);
}

export function Header({ onMenu }: { onMenu: () => void }) {
  const { t, i18n } = useTranslation();
  const loc = useLocation();
  const nav = useNavigate();
  const active = NAV_ITEMS.find((n) => (n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to)));
  const date = useDateLabel(i18n.language);

  return (
    <header className="flex items-center gap-3 border-b border-border bg-surface px-4 py-3 lg:px-7">
      <button className="btn-ghost -ms-2 lg:hidden" onClick={onMenu} aria-label={t('header.openMenu')}>
        <Menu size={20} />
      </button>
      <div className="flex min-w-0 items-baseline gap-3">
        <h1 className="truncate text-lg font-bold lg:text-xl">{t(active?.labelKey ?? 'app.name')}</h1>
        <span className="hidden text-xs text-text-muted md:inline">{date}</span>
      </div>
      <div className="flex-1" />
      <SearchBox />
      <div className="flex items-center gap-2">
        <Can perm="trips:create">
          <button className="btn-primary hidden sm:inline-flex" onClick={() => nav('/trips/new')}>
            <Plus size={16} strokeWidth={2.4} aria-hidden />
            {t('header.newTrip')}
          </button>
        </Can>
        <NotificationsMenu />
        <button
          className="btn-secondary size-10 !p-0"
          aria-label={t('common.language')}
          title={t('common.language')}
          onClick={() => void i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}
        >
          <Globe size={18} aria-hidden />
        </button>
      </div>
    </header>
  );
}
